import React, { useState } from 'react';

import { ClientContactsModalEditor } from './ClientContactsModalEditor';

export const useClientContactsModal = (onClosed?: () => void) => {
  const [clientId, setClientId] = useState<string>();

  const handleClose = () => {
    setClientId(undefined);
    onClosed?.();
  };

  return {
    open: (id: string) => setClientId(id),
    modal: (
      <ClientContactsModalEditor
        clientId={clientId}
        show={!!clientId}
        handleClose={handleClose}
      />
    ),
  };
};
